<template>
  <label
    class="inline-flex items-center cursor-pointer select-none p-5 leading-none w-full"
    :class="{ 'cursor-not-allowed opacity-50': disabled }"
  >
    <input
      :checked="modelValue"
      type="checkbox"
      class="hidden"
      :disabled="isDisabled"
      @input="$emit('update:modelValue', $event.target.checked)"
    >
    <span
      class="flex-shrink-0 relative h-17 w-17 border rounded-3"
      :class="[{ 'mr-10': label }, hasBg ? 'border-grey-100 shadow-grey-100' : 'border-grey-700 shadow-grey-700']"
    />
    <p class="truncate">{{ label }}</p>
  </label>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CheckboxModule',

  /* PROPS */
  props: {
    label: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: false },
    hasBg: { type: Boolean, default: false },
    disabledDeselect: Boolean
  },

  emits: ['update:modelValue'],

  computed: {
    isDisabled () {
      return (this.disabledDeselect && this.modelValue) || this.disabled
    }
  }
})
</script>

<style lang="scss" scoped>
input:checked ~ span:after {
  @apply block;
}

span:after {
  @apply w-7 h-15 border-link-color origin-center transform rotate-45 scale-75 border-r-2 border-b-2 absolute hidden left-4;
  top: -1px;
  content: "";
}
</style>
